<template></template>

<script>
export default {
    name: "ProductImpressions",

    props: {
        brandId: {
            type: [Number, String],
        }
    },

    data() {
        return {
            products: {}
        }
    },

    computed: {
        countryId() {
            return window.location.hostname;
        },

        productsForEc() {
            return _.map(this.products, (product, index) => {
                return _.extend({}, product, {
                    name: product.name?.toLowerCase(),
                    position: index + 1,
                    list: 'Product Overview Page'
                })
            });
        }
    },

    mounted() {
        this.getProductImpressionsData();
    },

    methods: {
        getProductImpressionsData() {
            axios.get(`/api/products-per-brand/${this.brandId}/${this.countryId}`)
                .then(response => {
                    this.products = response.data;
                })
                .catch (error => {
                    this.products = {};
                })
                .finally(() => this.pushToDataLayer());
        },

        pushToDataLayer() {
            if (_.isEmpty(this.products)) {
                return;
            }

            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                'event': 'ProductImpressions',
                'ecommerce': {
                    'currencyCode': 'EUR',
                    'impressions': this.productsForEc,
                }
            });
        }
    }
}
</script>